import { createApp } from 'vue';
import { initSentry, getEnvVar } from '@utils';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import Cloudinarize from '@plugins/cloudinarize';
import store from '@care-provider/stores/care-provider.store';
import router from '@care-provider/routes/care-provider.router';
import ProfileOnboarding from '../src/care-provider/components/profile-onboarding.vue';
import UserQuotes from '../src/static/components/user-quotes.vue';

initSentry();

const app = {
  store,
  router,
  components: {
    UserQuotes,
    ProfileOnboarding,
  },
};

createApp(app)
  .use(store)
  .use(router)
  .use(Cloudinarize)
  .use(VueReCaptcha, {
    siteKey: getEnvVar('RECAPTCHA_SITE_KEY'),
    loaderOptions: {
      useEnterprise: true,
      renderParameters: {
        badge: 'bottomleft',
      },
    },
  })
  .mount('#static_vue');
